export enum ActionTypes {
  Property = 'SetProperty',
  RemoveProperties = 'RemoveProperties',
  NotifyUsers = 'NotifyUsers',
  Kick = 'Kick',
  NotifyGroup = 'NotifyGroup',
  AddLabel = 'AddLabel',
  RemoveLabel = 'RemoveLabel',
  CreateInviteLink = 'CreateInviteLink',
  JoinRequest = 'JoinRequest',
  DeleteLastMessageAction = 'DeleteLastMessageAction',
  Ban = 'Ban',
  Publish = 'Publish'
}
